// Update `workerEncryptionVersion` when this is changed in `worker\constants\constants.ts`
// Update this if the structure of data, algorithm, or key changes.
export const appEncryptionVersion = 3;

/**
 *
 * @param responseBodyBytes The responseBodyBytes with the version information prepended as the first byte.
 * @returns If the version is as expected, it returns the responseBodyBytes without the version information (removes the first byte)
 */
export function verifyEncryptionVersion(responseBodyBytes: Uint8Array): Uint8Array {
    // See `encryption.workbox-plugin.ts` for details on how responses are stored in CacheStorage
    // Summary:
    // [1 Byte]         : Encryption Version.
    // [12 Bytes]       : Randomly generated bytes for initialization vector.
    // [Remaining Bytes]: Encrypted, utf-8 text-encoded data.

    // Read the first byte as the 'encryptionVersion'.
    const responseEncryptionVersion = responseBodyBytes.slice(0, 1)[0];

    if (responseEncryptionVersion !== appEncryptionVersion) {
        throw new Error(`Encryption Version Mismatch. Cannot Decrypt. Expected: ${appEncryptionVersion}. Received: ${responseEncryptionVersion}`);
    }

    const ivAndEncryptedData = responseBodyBytes.slice(1, responseBodyBytes.byteLength);

    return ivAndEncryptedData;
}
